import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NoticeViolation } from '../../../models/notice-violation.model';
import { NeighborhoodService } from '../../../services/neighborhood.service';
import { NoticeViolationService } from '../../../services/notice-violation.service';
import { StreetBuildingService } from '../../../services/street-building.service';
import { CreateNoticeViolationModalComponent } from '../../../components/create-notice-violation-modal/create-notice-violation-modal.component';
import { NoticeViolationModalComponent } from '../../../components/notice-violation-modal/notice-violation-modal.component';

@Component({
  selector: 'app-house-flat-notice-violations-page',
  templateUrl: './house-flat-notice-violations-page.component.html',
  styleUrl: './house-flat-notice-violations-page.component.scss'
})
export class HouseFlatNoticeViolationsPageComponent implements OnInit {

  public loading: boolean = true;
  public noticeViolations: NoticeViolation[] = [];

  public neighborhoodId: string = '';
  public streetBuildingId: string = '';
  public houseFlatId: string = '';

  /** "Calle 123 – Nombre del residente". Vacío hasta que se resuelve la casa. */
  public houseLabel: string = '';

  constructor(
    private modalService: NgbModal,
    public neighborhoodService: NeighborhoodService,
    private noticeViolationService: NoticeViolationService,
    private route: ActivatedRoute,
    private router: Router,
    private streetBuildingService: StreetBuildingService
  ) { }

  /** true solo cuando ya cargó ESTE fraccionamiento y su módulo está apagado. */
  get moduleDisabled(): boolean {

    const neighborhood = this.neighborhoodService.currentNeighborhood;

    return !!neighborhood
      && neighborhood.neighborhoodId === this.neighborhoodId
      && !neighborhood.noticeViolationModule;
  }

  /* -------------------------------------------------------------------------- */
  /*                               ANCHOR ngOnInit                              */
  /* -------------------------------------------------------------------------- */
  // region ngOnInit
  async ngOnInit() {

    this.neighborhoodId = this.route.snapshot.params['neighborhoodId'];
    this.streetBuildingId = this.route.snapshot.params['streetBuildingId'];
    this.houseFlatId = this.route.snapshot.params['houseFlatId'];

    await Promise.all([
      this.loadData(),
      this.loadHouse()
    ]);

  }

  /* -------------------------------------------------------------------------- */
  /*                               ANCHOR loadData                              */
  /* -------------------------------------------------------------------------- */
  // region loadData
  async loadData() {

    this.loading = true;

    this.noticeViolations = await this.noticeViolationService.getByHouseFlat(
      this.neighborhoodId,
      this.streetBuildingId,
      this.houseFlatId
    );

    this.loading = false;

  }

  /* -------------------------------------------------------------------------- */
  /*                               ANCHOR loadHouse                             */
  /* -------------------------------------------------------------------------- */
  // region loadHouse
  async loadHouse() {

    const findHouse = () => {

      const streetBuilding = this.streetBuildingService.streetsBuildings.find(
        (item) => item.streetBuildingId === this.streetBuildingId
      );

      const houseFlat = streetBuilding?.housesFlats.find(
        (item) => item.houseFlatId === this.houseFlatId
      );

      return { streetBuilding, houseFlat };

    };

    let { streetBuilding, houseFlat } = findHouse();

    /* Entrando directo por la URL la lista de calles puede no estar cargada. */
    if (!houseFlat) {
      await this.streetBuildingService.getAll(this.neighborhoodId);
      ({ streetBuilding, houseFlat } = findHouse());
    }

    if (streetBuilding && houseFlat) {
      this.houseLabel = houseFlat.fullName
        ? `${streetBuilding.name} ${houseFlat.number} – ${houseFlat.fullName}`
        : `${streetBuilding.name} ${houseFlat.number}`;
    }

  }

  /* -------------------------------------------------------------------------- */
  /*                               ANCHOR create                                */
  /* -------------------------------------------------------------------------- */
  // region create
  create() {

    const modalRef = this.modalService.open(
      CreateNoticeViolationModalComponent
    );

    modalRef.componentInstance.neighborhoodId = this.neighborhoodId;
    modalRef.componentInstance.streetBuildingId = this.streetBuildingId;
    modalRef.componentInstance.houseFlatId = this.houseFlatId;

    modalRef.result.then(
      () => this.loadData(),
      () => this.loadData()
    );

  }

  /* -------------------------------------------------------------------------- */
  /*                                 ANCHOR view                                */
  /* -------------------------------------------------------------------------- */
  // region view
  view(
    noticeViolation: NoticeViolation,
    editable: boolean = false
  ) {

    const modalRef = this.modalService.open(
      NoticeViolationModalComponent
    );

    modalRef.componentInstance.noticeViolation = noticeViolation;
    modalRef.componentInstance.neighborhoodId = this.neighborhoodId;
    modalRef.componentInstance.editable = editable;

    modalRef.result.then(
      () => this.loadData(),
      () => this.loadData()
    );

  }

  /* -------------------------------------------------------------------------- */
  /*                               ANCHOR delete                                */
  /* -------------------------------------------------------------------------- */
  // region delete
  async delete(
    noticeViolation: NoticeViolation
  ) {

    const flag = confirm(
      `¿Está seguro que desea borrar la amonestación "${noticeViolation.title}"? Se eliminarán también sus archivos y notificaciones.`
    );

    if (flag) {

      const deleted = await this.noticeViolationService.delete(noticeViolation);

      if (deleted) {
        await this.loadData();
      }

    }

  }

  /* -------------------------------------------------------------------------- */
  /*                                ANCHOR goBack                               */
  /* -------------------------------------------------------------------------- */
  // region goBack
  goBack() {
    this.router.navigate([
      '/neighborhoods',
      this.neighborhoodId,
      'streets-buildings'
    ]);
  }

}
